var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOff = function SvgOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.09 2v10.083h1.82V2h-1.82Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m7.689 4.954.772-.48L7.5 2.93l-.772.48A9.994 9.994 0 0 0 2 11.91c0 5.522 4.477 10 10 10s10-4.478 10-10a9.994 9.994 0 0 0-4.729-8.5l-.772-.48-.96 1.544.772.48a8.182 8.182 0 1 1-8.623 0Z",
    fill: "currentColor"
  })));
};
export { SvgOff as ReactComponent };
export default __webpack_public_path__ + "49090562b4a4908386ddada8f30a2941.svg";